/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/*==================
	#Master Slider
==================*/


$('.nhp-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows:false,
  dots: true
});


/*==================
	#Quick View
==================*/

$(document).on('click', '.quick-view-button', function(){
  console.log('clicked');
  var qvtitle = $(this).parent().data('quickviewtitle');
  var qvprice = $(this).parent().data('quickviewprice');
  var qvprice2 = $(this).parent().data('quickviewprice2');
  var qvdesc = $(this).parent().data('quickviewdesc');
  var qvimg = $(this).parent().data('quickviewimg');
  var qvurl = $(this).parent().data('quickviewurl');
  var qvpurchase = $(this).parent().data('quickviewpurchase');
  
  console.log(qvurl)
  
  $('.quick-view-title').html(qvtitle);
  if(!qvprice2){
      $('.quick-view-price').html('Costco Price <br>'+qvprice);
    $('.quick-view-price2').html('');
  }else{
    $('.quick-view-price').html('Promo Price <br>'+qvprice);
    $('.quick-view-price2').html('Costco Price <br><span>'+qvprice2+'</span>');
  }
  
  // $('.quick-view-price').html('Costco Price <br>'+qvprice);
  // $('.quick-view-price2').html('Regular Price <br><span>'+qvprice2+'</span>');
  
  $('.quick-view-desc').html(qvdesc);
  $('.quick-view-image img').attr('src', qvimg);
  $('.quick-view-more').attr('href', qvurl);
  $('.quick-view-purchase').val(qvpurchase);
  
  $('.quick-view-blackout').removeClass('hidden');
});

$(document).on('click', '.quick-view-close', function(){
  $('.quick-view-blackout').addClass('hidden');
  $('.quick-view-image img').attr('src', '');
});

$(document).on('submit', '.quick-view form', function(event){
  event.preventDefault(); // Prevent form to be submitted
  var addToCartButton = event.target.querySelector('.ProductForm__AddToCart');

  // First, we switch the status of the button
  addToCartButton.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  // Then we add the product in Ajax
  var formElement = event.target;  
  let formData = {
   'items': [{
    'id': parseInt(formElement.querySelector('[name="id"]').value),
    'quantity': 1
    }]
  };
  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify(formData),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      addToCartButton.removeAttribute('disabled');
      // We simply trigger an event so the mini-cart can re-render
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: formElement.querySelector('[name="id"]').value,
          quantity: 1
        }
      }));
    } else {
      response.json().then(function (content) {
        alert(content['description']);
      });
    }
  });

  event.preventDefault();
  
});